import { render, staticRenderFns } from "./languages.item.vue?vue&type=template&id=413cdf58"
import script from "./languages.item.vue?vue&type=script&lang=js"
export * from "./languages.item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports